/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * FormInput.tsx
 */

import HiloReactComponent from "../layout/HiloReactComponent";
import React from "react";
import {FormElementProps} from "./FormElement";
import {FormInputEvent} from "./FormInput";

interface Props<D> extends FormElementProps<D> {
    onChange?: FormInputEvent<D>;
}

interface State {
    value: any
}

export default class FormCheckbox<D> extends HiloReactComponent<Props<D>, State> {
    constructor(props: Props<D>, state: State) {
        super(props, state);

        this.state = {
            value: props.field.value
        }
    }

    /**
     * componentDidMount
     */
    public componentDidMount(): void {
        this.setState({value: this.props.field.value});
    }

    /**
     * componentDidUpdate
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    public componentDidUpdate(prevProps: Readonly<Props<D>>, prevState: Readonly<State>, snapshot?: any): void {
        if (this.state.value !== this.props.field.value) {
            this.setState({value: this.props.field.value});
        }
    }

    /**
     * render
     * @returns {any}
     */
    public render() {
        const {field, onChange} = this.props;

        return <div className="field">
            <span>{field.title(this.t)}</span>
            <p>
                <input className={"checkbox form-checkbox"} checked={!!field.value} type={field.type.toString()}
                       disabled={field.disabled} key={field.name} onChange={e => {
                    onChange?.(field.name, (!field.value) as unknown as D);
                }}/>
            </p>
        </div>;
    }
}